import React, { Fragment } from 'react';

const FeatureList = ({ featureList, includeLink = false }) => (
    <Fragment>
        {featureList && featureList.length > 0 && <ul className="feature-list">
            {featureList.map((item, index) => {
                const hasTitle = item.title || item.Title;
                if (!hasTitle) {
                    return null;
                }
                return item.iconHtml != null && item.iconHtml != undefined ? 
                <li key={index} className={item.text != undefined && item.text.value ? "has-info" : ""}>
                    <a href={includeLink ? item.link?.href : ""}>
                        {item.iconHtml && <div className="feature-list__icon" dangerouslySetInnerHTML={{ __html: item.iconHtml }}></div>}
                        <div className="feature-list__title">{item.title}</div>
                    </a>
                    {item.text != undefined && item.text.value && <div className="feature-list__info-details">
                        <div className="feature-list__info-details-title">{item.title != undefined ? item.title : ""}</div>
                        <div dangerouslySetInnerHTML={{ __html: (item.text != undefined ? item.text.value : "") }}></div>
                    </div>}
                </li> :
                    <li key={index} className={item.Text != undefined && item.Text.Value ? "has-info" : ""}>
                        <a href={includeLink ? item.link?.href : ""}>
                            {item.IconHtml && <div className="feature-list__icon" dangerouslySetInnerHTML={{ __html: item.IconHtml }}></div>}
                            <div className="feature-list__title">{item.Title}</div>
                        </a>
                        {item.Text != undefined && item.Text.Value && <div className="feature-list__info-details">
                            <div className="feature-list__info-details-title">{item.Title != undefined ? item.Title : ""}</div>
                            <div dangerouslySetInnerHTML={{ __html: (item.Text != undefined ? item.Text.Value : "") }}></div>
                        </div>}
                    </li>
            })}
        </ul>
        }
    </Fragment>
)

export default FeatureList;